import { SHA256 } from "crypto-js";
function sha256Hash(data) {
    const hash = SHA256(data);
    const hashWords = hash.words;
    const hashArray = [];
    for (let i = 0; i < hashWords.length; i++) {
        const word = hashWords[i];
        for (let j = 3; j >= 0; j--) {
            hashArray.push((word >> (8 * j)) & 0xff);
        }
    }
    return hashArray.map((b) => ("00" + b.toString(16)).slice(-2)).join("");
}
export function generateSignature(params) {
    console.log(params);
    const signature = sha256Hash(`${params}137981`);
    return signature;
}
//# sourceMappingURL=incode.js.map